import { render, staticRenderFns } from "./fccEmuladosInternos.vue?vue&type=template&id=523386bc"
import script from "./fccEmuladosInternos.vue?vue&type=script&lang=js"
export * from "./fccEmuladosInternos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports